const footerHeadings = [...document.querySelectorAll('.js-collapse-heading')];

footerHeadings.map(heading => heading.addEventListener('click', () => {
    if (heading.hasAttribute('data-open')) {
        heading.nextElementSibling.style.height = 0;
        heading.removeAttribute('data-open');
    } else {
        heading.setAttribute('data-open', '');
        heading.nextElementSibling.style.height = `${heading.nextElementSibling.scrollHeight}px`;
    }
}));
